import React from 'react';
import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	List,
	ListGutter,
	ListItem,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { ServiceGroupType, ServiceLayer } from '../../models/services-layer-types';

export const longDriveNoInformadoLayer: ServiceLayer = {
	id: ServiceGroupType.Coberturas,
	header: 'Coberturas',
	title: 'Volkswagen Long Drive',
	subtitle: (
		<Text appearance={TokenTextAppearance.copy200}>
			Con tu suscripción de mantenimiento, lo tienes todo incluido en una única cuota mensual. Así, cuando pases por
			taller, no tendrás que preocuparte por cuánto costará.
		</Text>
	),
	description: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0100}>
			<Text appearance={TokenTextAppearance.headline200} bold>
				Según el plan que hayas elegido, tienes las siguientes operaciones incluidas:
			</Text>
			<Container wrap="always" padding={{ left: ContainerPadding.dynamic0050 }}>
				<Text appearance={TokenTextAppearance.copy200}>
					<List gutter={ListGutter.dynamic0020}>
						<ListItem>Standard: incluye el mantenimiento de tu coche.</ListItem>
						<ListItem>Advance: incluye el mantenimiento y cambio de piezas por desgaste de tu coche.</ListItem>
						<ListItem>Pro: incluye el mantenimiento, cambio de piezas por desgaste y neumáticos de tu coche.</ListItem>
					</List>
				</Text>
			</Container>

			<Text appearance={TokenTextAppearance.copy200}>
				Además, todos los planes incluyen asistencia en carretera 24/7 y coche de sustitución en caso de avería.
			</Text>

			<Text appearance={TokenTextAppearance.copy200}>
				Para hacer cambios en tu suscripción, accede al{' '}
				<CTA
					tag="a"
					emphasis="tertiary"
					href="https://www.fs-tools.es/volkswagenlongdriveservice"
					aria-label="Portal de Long Drive."
					target="_blank"
				>
					<Text color={TokenTextColor.primary}>portal de Long Drive.</Text>
				</CTA>
			</Text>
		</Container>
	),
	imageContent:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-long-drive-cuadrado?Zml0PWNyb3AlMkMxJndpZD04OTYmaGVpPTg5NiZmbXQ9anBlZyZxbHQ9NzkmYmZjPW9mZiZlMmRh',
};
